<script>
  let { title, actions, children } = $props()
</script>

<div class="card bg-base-100 border border-base-300 shadow-sm">
  {#if title || actions}
    <div class="card-body pb-0">
      <div class="flex items-center justify-between">
        {#if title}<h2 class="card-title">{title}</h2>{/if}
        {#if actions}<div>{@render actions()}</div>{/if}
      </div>
    </div>
  {/if}
  <div class="card-body">
    {@render children?.()}
  </div>
</div>
